import constants from '@/core/constants'
import _ from 'lodash'
import messageBus from '@/core/message-bus'
import authorizationService from '@/core/auth/authorization-service'
import featureService from '@/core/services/feature-service'
import { formatDate, formatPhoneNumber } from '@/core/formatting'
import localizationService from '@/core/services/localization-service'

const mixin = {
  data: () => ({
    subscriptions: []
  }),
  methods: {
    formatDate,
    formatPhoneNumber,
    subscribe(key, callback) {
      messageBus.subscribe(key, callback)
      this.subscriptions.push({ key, callback })
    },
    publish(key, data) {
      messageBus.publish(key, data)
    },
    hasFeature(name) {
      return featureService.hasFeature(name)
    },
    getImagePath(relativeSrc) {
      return _.get(this.$store.getters, 'configuration.ServerDnsName', '') + relativeSrc
    },
    get() {
      return _.get(...arguments)
    }
  },
  beforeDestroy() {
    _.forEach(this.subscriptions, subscription => {
      messageBus.unsubscribe(subscription.key, subscription.callback)
    })
  },
  computed: {
    currentErrand() {
      return this.$store.getters.currentErrand
    },
    localErrand() {
      return _.get(this.currentErrand, 'localErrand', {})
    },
    errandId() {
      return this.$route.params.errand_id
    },
    isSparkProUser() {
      return featureService.isSparkProUser()
    },
    isBusinessPartner() {
      return authorizationService.hasRole(constants.roles.businessPartner)
    },
    isEndCustomer() {
      return authorizationService.hasRole(constants.roles.endCustomer)
    },
    isGlobalAdmin() {
      return authorizationService.hasRole(constants.roles.globalAdmin)
    },
    isContentManager() {
      return authorizationService.hasRole(constants.roles.contentManager)
    },
    isReadOnly() {
      return !!authorizationService.getClaim(constants.customClaims.readOnly)
    },
    currentUserCompany() {
      return this.$store.getters.currentUserCompany
    },
    username() {
      return authorizationService.getClaim('unique_name')
    },
    displayName() {
      return authorizationService.getClaim('display_name')
    },
    isDevelopment() {
      return process.env.NODE_ENV === 'development'
    },
    isOnErrandsPage() {
      return this.$route.fullPath === '/'
    },
    currentIsoCode() {
      return localizationService.getCurrentIsoCode()
    },
    errandMembers() {
      return this.$store.getters.members
    }
  }
}

export default mixin
